//@flow
import React, {useState} from 'react';

import {makeStyles} from '@material-ui/core';

import CustomModal from '../../../../../../elements/CustomModal/CustomModal';

import type {ScheduleMessage} from '../../../../../../entities';
import ConfirmModal from '../../../../../../elements/Modals/ConfirmModal';
import {
  useScheduleMessageActions,
  useCurrentConversationScheduleMessage,
} from '../../../../schedule-messages/utils';
import ScheduleMessageCard from '../../../../schedule-messages/components/ScheduleMessageCard';
import ScheduleMessageForm from '../../../../schedule-messages/components/ScheduleMessageForm';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
    maxHeight: 400,
    overflowY: 'auto',
  },
}));

export default function ScheduleMessageList() {
  const classes = useStyles();

  const [
    scheduleMessage,
    setScheduleMessage,
  ] = useState<ScheduleMessage | null>(null);

  const [messageIdToDelete, setMessageIdToDelete] = useState<string>('');
  const {deleteScheduleMessages} = useScheduleMessageActions();
  const {scheduleMessages} = useCurrentConversationScheduleMessage();

  return (
    <div className={classes.root}>
      {scheduleMessages.map(scheduleMessage => (
        <ScheduleMessageCard
          message={scheduleMessage}
          onDelete={id => setMessageIdToDelete(id)}
          onEdit={id => {
            setScheduleMessage(scheduleMessage);
          }}
        />
      ))}

      <CustomModal
        open={!!scheduleMessage}
        handleCloseModal={() => {
          setScheduleMessage(null);
        }}
      >
        {scheduleMessage && (
          <ScheduleMessageForm
            onSuccessfulSubmit={() => {
              setScheduleMessage(null);
            }}
            scheduleMessage={scheduleMessage}
          />
        )}
        <br />
      </CustomModal>

      <ConfirmModal
        open={!!messageIdToDelete}
        message="Esta acción no se puede deshacer"
        title="¿Estás seguro de eliminar este mensaje programado?"
        onCancel={() => setMessageIdToDelete('')}
        onConfirm={() => {
          deleteScheduleMessages(messageIdToDelete);
          setMessageIdToDelete('');
        }}
        onClose={() => setMessageIdToDelete('')}
      />
    </div>
  );
}
